/**
 * SPEC-COOKIE — consent configuration shared by the banner, the manage
 * modal, and the consent util. Bump POLICY_VERSION whenever the cookie
 * policy text materially changes; visitors on an older version are
 * re-prompted (their stored decision no longer matches).
 *
 * Framework-free on purpose so COOKIE-3 can drop this file into the portal
 * verbatim. Pure constants + types — no React, no Supabase, no i18n.
 */
export const POLICY_VERSION = "2026-05-31";

/** Parent-domain cookie so ALL *.quanitra.com subdomains share one decision. */
export const CONSENT_COOKIE_NAME = "quanitra_consent";
/** Leading dot → shared across subdomains (portal + every tool). */
export const CONSENT_COOKIE_DOMAIN = ".quanitra.com";
/** 12 months (typical for consent cookies; re-ask yearly). */
export const CONSENT_COOKIE_MAX_AGE_DAYS = 365;

/** This site's provenance tag written to the DB `source` column. */
export const CONSENT_SOURCE = "ifrs16";

export type ConsentCategory = "necessary" | "analytics" | "marketing";
export type ConsentAction = "accept_all" | "reject" | "custom";

export interface ConsentDecision {
  /** Always on by definition — necessary cookies cannot be declined. */
  necessary: true;
  analytics: boolean;
  marketing: boolean;
  action: ConsentAction;
  policyVersion: string;
  /** Anonymous browser id (UUID), minted on first decision. */
  consentId: string;
  /** ISO timestamp of the decision. */
  decidedAt: string;
}
